import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"
// Components
import Navbar from "../../components/Navbar/Navbar"
import Footer from "../../components/Footer/Footer"
import ShopMap from "../../components/ShopMap"
import { Search } from "@mui/icons-material"
// Data
import { publicRequest } from "../../requestMethods"
// Styles
import {
   Container,
   Wrapper,
   SearchContainer,
   Input,
   List,
   ListItem,
   Title,
   Text,
} from "./ShopFinder.styles"

const ShopFinder = () => {
   const { t } = useTranslation()
   const [searchTerm, setSearchTerm] = useState("")
   const [shops, setShops] = useState([])
   const [filteredShops, setFilteredShops] = useState([])
   const [selectedShop, setSelectedShop] = useState({})

   const handleSearch = (searchInput) => {
      const value = searchInput.toLowerCase()
      setSearchTerm(value)
      setFilteredShops(
         shops.filter(
            (shop) =>
               shop.city.toLowerCase().includes(value) ||
               shop.zip.includes(value)
         )
      )
   }

   useEffect(() => {
      window.scrollTo(0, 0)
   }, [])

   useEffect(() => {
      const getShops = async () => {
         const res = await publicRequest.get("shops")
         setShops(res.data)
      }
      getShops()
   }, [setShops])

   return (
      <>
         <Helmet>
            <title>{t("shopFinderPage.meta.meta_title")}</title>
            <meta
               name="description"
               content={t("shopFinderPage.meta.meta_description")}
            />
         </Helmet>
         <Container>
            <Navbar bgImageColor="light" />
            <Wrapper>
               <Title>{t("shopFinderPage.title.t1")}</Title>
               <Text>{t("shopFinderPage.text.t1")}</Text>
               <SearchContainer>
                  <Input
                     type="text"
                     value={searchTerm}
                     placeholder={t("shopFinderPage.input.i1")}
                     onChange={(e) => handleSearch(e.target.value)}
                  />
                  <Search style={{ cursor: "pointer" }} />
               </SearchContainer>
               {searchTerm ? (
                  <List>
                     {filteredShops.map((shop, index) => (
                        <ListItem
                           key={index}
                           onClick={() => setSelectedShop(shop)}
                        >
                           {shop.name} - {shop.city} ({shop.zip})
                        </ListItem>
                     ))}
                  </List>
               ) : (
                  <></>
               )}
               <ShopMap shops={shops} selectedShop={selectedShop} />
            </Wrapper>
            <Footer />
         </Container>
      </>
   )
}

export default ShopFinder
